import React, { FC, useEffect, useRef } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Box } from '@moonpig/launchpad-components'
import { useProductStore } from '../../contexts/product'

const StyledBox = styled(Box)`
  max-width: 850px;
  ${s({
    pb: { xs: '24vh', md: 0 },
  })}
`

type Props = {
  scrollWholeModal?: boolean
}

export const ScrollToTop: FC<React.PropsWithChildren<Props>> = ({
  children,
  scrollWholeModal = false,
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [{ product }] = useProductStore()

  useEffect(() => {
    if (!scrollWholeModal) {
      contentRef.current?.scrollIntoView?.({
        behavior: 'instant',
        block: 'start',
      })
      return
    }

    let container = contentRef.current?.parentElement

    while (container && container !== document.body) {
      container.scrollTo?.({ top: 0, behavior: 'smooth' })
      container = container.parentElement
    }
  }, [product, scrollWholeModal])

  return <StyledBox ref={contentRef}>{children}</StyledBox>
}
